<div class="container-login">
    <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-12 col-md-9">
            <div class="card shadow-sm my-5">
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-lg-12">
                            <img src="../../../assets/img/logo/triangle.png" style="width: 100%;">
                            <div class="login-form">
                                <div class="text-center">
                                    <h1 class="h4 text-gray-900 mb-4" style="color: #1A355E;">Novatel Billing System</h1>
                                </div>
                                <form class="user" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                    <div class="form-group">
                                        <input type="email" class="form-control" formControlName="username"
                                            placeholder="Kullanıcı Adı">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" formControlName="password"
                                            placeholder="Şifre">
                                    </div>
                                    <button class="btn btn-lg btn-primary btn-block" type="submit"
                                        [disabled]="loginForm.invalid">Giriş</button>
                                </form>
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>